export enum ViewType {
    BASE = "base",
    TILES = "tiles",
}

export const ADAPTIVE = "adaptive";

export type ViewVariant = ViewType | typeof ADAPTIVE;
